var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('legend',[_c('b-badge',{staticClass:"legend-title"},[_vm._v("Encuestas")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }